var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MsAjaxTemplate',{ref:"tmpl",staticClass:"entry-details",class:_vm.sizeClass,attrs:{"id":"c-entrydetails","template-name":"entry-details","get-template-data":_vm.getTemplateData,"ready-dependencies":['entrydetails', 'ExoWeb.dom', 'Cognito.Forms.controller', 'admin-component-library', 'admin-form-api']}})
}
var staticRenderFns = []

export { render, staticRenderFns }